import React from "react";
import { FormattedMessage } from "react-intl";
import { components } from "@usher/pe-client-front-end-lib";
import { defaultSelectStyles } from "@/constants/defaultSelectStyles";

type CurrencyChartSelectorsProps = {
  rate: { value: number; change: number };
  fiatSymbol: string;
  cryptoSymbol: string;
  onChangeFiat: (symbol: string) => void;
  onChangeCrypto: (symbol: string) => void;
};

export const CurrencyChartSelectors = ({
  rate,
  fiatSymbol,
  cryptoSymbol,
  onChangeFiat,
  onChangeCrypto,
}: CurrencyChartSelectorsProps) => {
  return (
    <div className="chart-changed__header d-flex justify-content-between">
      <div className="chart-changed__choose">
        <div className="chart-changed__select-crypto">
          <components.DefaultSelectNative
            type="crypto"
            styles={defaultSelectStyles}
            className="select-sm select-fix-width"
            classNamePrefix="ss"
            selected={{ label: cryptoSymbol, value: cryptoSymbol }}
            onChange={({ value }) => onChangeCrypto(value)}
            isSearchable={false}
            key_equals_value={true}
          />
        </div>
        <div className="chart-changed__choose-info d-flex align-items-center">
          <span className="chart-changed__choose-value">
            {Math.trunc(rate.value)}.
            <span>{Math.round(rate.value * 100) % 100}</span>
          </span>
          <components.DefaultSelectNative
            type="fiat"
            styles={defaultSelectStyles}
            className="select-lg select-fix-width"
            classNamePrefix="ss"
            selected={{ label: fiatSymbol, value: fiatSymbol }}
            onChange={({ value }) => onChangeFiat(value)}
            isSearchable={false}
            key_equals_value={true}
          />
        </div>
      </div>
      <div className="chart-changed__value">
        <span className="chart-changed__value-title">
          <FormattedMessage id="changed_since" />{" "}
          <span>
            <FormattedMessage id="last_day" />
          </span>
        </span>
        <div className="chart-changed__value-info">
          <span className="chart-changed__value-sum">
            {Math.abs((rate.value * rate.change) / 100).toFixed(2)}
            <span> {fiatSymbol}</span>
          </span>
          <span
            className={
              "chart-changed__value-grow text-" +
              (rate.change > 0 ? "success" : "danger") +
              " up"
            }
          >
            {rate.change}%
          </span>
        </div>
      </div>
    </div>
  );
};
